<template>
<!--transition name="mod" mode="out-in"-->
    <div class="mod-container" :class="(dark ? 'mod-dark' : '')">
      <h4>Lessons</h4>
      <div class="lesson-list-container">
          <div class="project-list">
              <ul style="padding:0px">
                  <!-- why are vertical ternaries so pretty yet so ugly -->
                  <router-link
                  
                    v-for="(item, index) in 
                    ( 
                        $route.params.current == 'advisory'
                        ? 
                        quizzes.advisory
                        : 
                        (
                            $route.params.current == 'managed_services' 
                            ?
                            quizzes.managedServices 
                            : 
                            (
                                $route.params.current == 'operations'
                                ?
                                quizzes.operations 
                                :
                                quizzes.keno
                            )
                            
                        )
                    )" 

                    :to="'/lesson/' + item.lessonID"
                    
                    :key="item.i"
                    
                    >
                    <li>
                        <div 
                            class="project-item" 
                            :class="(globalCompleted.includes(parseInt(item.lessonID)) ? 'completed' : '')" 
                            :style="(globalCompleted.includes(parseInt(item.lessonID)) 
                                ? 'background-color:' + color + ' !important; color: white !important;' + 'animation: flyin 300ms forwards ease ' + parseFloat(index / 6) + 's' 
                                : 'background-color:#00000000;' + 'animation: flyin 300ms forwards ease ' + parseFloat(index / 6) + 's')" >
                            <div class="left"><strong>{{ item.practiceGroup }}</strong><span>{{ item.serviceLine }}</span></div>
                            <div class="right">{{ globalCompleted.includes(parseInt(item.lessonID)) ? '✓' : '🡒' }}</div>
                        </div>
                    </li>

                </router-link>
              </ul>
          </div>
      </div>
    </div>
<!--/transition-->
</template>
 
<script>
import store from '../store';
import firebase from 'firebase';

//const POST_LOGOUT_REDIRECT_URI = 'https://hbrc-18a6e.web.app';
//const ISSUER = 'https://dev-347385.okta.com/oauth2/default';
//const ISSUER = 'https://hbrconsulting.okta.com/oauth2/default';

export default {
    data() {
        return {
            userRef: { 

                progress: {
                    advisory: null,
                    managed_services: null,
                    operations: null,
                    keno: null
                },
                completed: []
            },
            quizzes: {
                advisory: [],
                managedServices: [],
                operations: [],
                keno: []
            },
            contextSorted: [],
            globalCompleted: []
        }
    },
    props: {
        user: Object,
        claims: Object
    },
    computed: {
        color() {
            if(this.$route.params.current == 'managed_services') {
                return '#20356A'
            }
            else if(this.$route.params.current == 'advisory') {
                return '#2E4FA3'
            }
            else if(this.$route.params.current == 'operations'){
                return '#478A69'
            }
            else {
                return "#FFCC00"
            }
        },
        dark() {
            return store.state.dark;
        }
    },
    created() {
        var self = this;
        //self.setup();
        self.bindData();
        self.fetchQuizzes();
        //console.clear();
        console.log('GRABBED COMPLETED ARRAY', self.userRef.completed);
    },
    mounted() {
    },
    methods: {
        fetchQuizzes() {
            var self = this;
            console.log('fetching lessons');
            firebase.firestore().collection('quizzes').orderBy("practiceGroup").get().then((docs) => {
                docs.forEach((doc) => {
                    console.log();
                    //console.log(doc.data());
                    console.log();
                    if(doc.data().module == 'Advisory') {
                        self.quizzes.advisory.push(doc.data());
                    }
                    else if(doc.data().module == 'Managed Services') {
                        self.quizzes.managedServices.push(doc.data());
                    }
                    else if(doc.data().module == 'Operations') {
                        self.quizzes.operations.push(doc.data());
                    }
                    else if(doc.data().module == 'Keno'){
                        self.quizzes.keno.push(doc.data());
                    }
                    else {
                        console.error('Unkown module');
                    }
                });
                console.log();
                console.log('quizzes fetched: ');
                console.log(self.quizzes.advisory);
                console.log(self.quizzes.managedServices);
                console.log(self.quizzes.operations);
                console.log(self.quizzes.keno);

                // ---------- filter quizzes ----------
                
                self.filterQuizzes(self.quizzes.advisory);
                self.filterQuizzes(self.quizzes.managedServices);
                self.filterQuizzes(self.quizzes.operations);
                self.filterQuizzes(self.quizzes.keno)
            });
        },
        filterQuizzes(context) {
            const na = [...new Set(context)]; // set

            var sorted = [];
            var trash = [];
        
            na.forEach((item) => {
                if(!trash.includes(item.serviceLine)) {
                    sorted.push({practiceGroup: item.practiceGroup, serviceLine: item.serviceLine, lessonID: item.lessonID});
                    trash.push(item.serviceLine);
                    //console.log(item.serviceLine);
                }
            });
            
            if(context == this.quizzes.advisory) { //advisory
                this.quizzes.advisory = sorted;
            }
            else if(context == this.quizzes.managedServices) { //managedServices
                this.quizzes.managedServices = sorted;
            }
            else if(context == this.quizzes.operations) { //operations
                this.quizzes.operations = sorted;
            }
            else { //keno
                this.quizzes.keno = sorted;
            }
        },
        bindData() {
            var self = this;
            var fireRef = firebase.firestore().collection('users');

            firebase.auth().onAuthStateChanged((user) => {
                var ur;

                if(user) {
                    console.log('user: ', user);
                    ur = user;

                    fireRef.doc(ur.uid).get().then((doc) => {
                        console.log('doc exists');
                        console.log(doc.data());
                        self.userRef.progress.advisory = doc.data().progress.advisory;
                        self.userRef.progress.managed_services = doc.data().progress.managed_services;
                        self.userRef.progress.operations = doc.data().progress.operations;
                        self.userRef.progress.keno = doc.data().progress.keno;
                        self.userRef.completed = doc.data().completed;
                        console.log(self.userRef.completed);
                        console.log(doc.data().completed);

                        console.log('COMPLETED', self.userRef.completed);
                        self.filterCompleted();
                    });
                } else {
                    console.log('no user signed in');
                }   
            });

            //console.log('data successfully binded.');
        },
        /*async setup() {
            console.log('setup jazz');
            this.claims = await this.$auth.getUser()
            console.log(this.claims);
            this.bindData();
        },
        async isAuthenticated() {
            this.authenticated = await this.$auth.isAuthenticated();
        },
        async logout() {
            console.log('logging out...');
            // read idToken before local session is cleared
            const idToken = await this.$auth.getIdToken();
            // clear local session
            await this.$auth.logout();
            // clear remote session
            //window.location.href = `${ISSUER}/v1/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${POST_LOGOUT_REDIRECT_URI}`
        },*/
        /*checkCompleted(item) {
            if(self.globalCompleted.contains(item.lessonID)) {
                return true;
            }
            else { //this item is not completed
                return false;
            }
        },*/
        filterCompleted() {
            var self = this;

            self.userRef.completed.forEach((completedItem) => {
                self.globalCompleted.push(completedItem.lessonID);
            });

            console.log('GLOBAL COMPLETED', self.globalCompleted);
            //console.clear();
            console.log('dashMod', store.state.dashMod);
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/global-styles/variables.scss';

h4 {
  padding: $gap 0px 0px $gap;
}

.completed {
    background: green !important;
    pointer-events: none;
    //color: white;

    .right {
        color: black !important;
        background: white !important;
    }
}

a {
    text-decoration: none;
    color: black !important;
}

.last-lesson {
    //animation: flyleft 800ms forwards ease 1s !important;
}

.mod-container {
    //display: none;
    background: white;
    border-radius: $rad;
    height: 418px;
    // margin-left: -650px;
    //margin-top: $gap / 2;
    //width: 100%;
    animation: flyleft 800ms forwards ease;
    padding-bottom: $gap;
}

.lesson-list-container {
    background: white;
    height: 375px;
    width: 912px;
    border-radius: $rad;
    text-align: left;
    //opacity: 0;
    overflow: auto;
    //firefox scrollbar
    overflow-y: scroll;
    scrollbar-color: gray transparent;
    scrollbar-width: thin;

    p {
        padding-left: 24px;
    }

    strong {
        font-weight: bold !important;
        opacity: 1 !important;
    }

    span {
        opacity: 0.6 !important;
    }

    .project-item:hover, .completed:hover {
        background: #eeeeee !important;
        .right {
            background: #00000077 !important;
            color: white;
        }
    }
}

.mod-dark {
    background: $colorDarkLight;

    .lesson-list-container {
        background: $colorDarkLight !important;
        color: white !important;
    }

    a {
        color: white !important;
    }
    strong {
        font-weight: normal !important;
        opacity: 0.4 !important;
    }

    span {
        opacity: 1 !important;
    }

    .project-item:hover, .completed:hover {
        background: #00000044 !important;
        .right {
            background: #ffffff11 !important;
            //color: black;
        }
    }
}

.lesson-list-title {
    margin-left: 12px;
    margin-top: 42px;
    margin-bottom: 0px;
}

@keyframes appear {
    from {
        //filter: invert(0);
        transform: translateY(164px);
        opacity: 0;
    }
    to {
        //filter: invert(1);
        transform: translateY(0px);
        opacity: 1;
    }
}

.project-list {
    //padding-bottom: 24px;

    .lesson-list-title {
        background: white !important;
        color: black !important;
    }

    .project-item {
        display: flex;
        justify-content: space-between;

    }   

    .right {
        //background: red;
        height: 32px;
        width: 32px;
        border-radius: 100%;
        margin: 0px;
        text-align: center;
        line-height: 32px;
    }

    .left {
        line-height: 32px;
    }

    ul {
        list-style: none;
    }

    li {
        padding-bottom: 12px;
    }

    &:hover {
        //background: yellow !important;
    }
}

li {
    cursor: pointer !important;
    
    &:hover {
        //background: red !important;
    }
}

.project-item {
    opacity: 0;
    margin-right: $gap;
    margin-left: $gap;
    padding: 12px 12px 12px 24px;
    border-radius: $rad * 2;
    cursor: pointer;
    transition: 150ms;

    strong {
        opacity: 0.4;
        font-weight: normal;
    }

    span {
        opacity: 1;
        margin-left: 12px;
    }

    &:hover {
        background: rgba(0,0,0,0.1);

        .right {
            background: #ffffff22 !important;
        }
    }
}

//transition animation fade

.mod-enter, .mod-leave-to {
  opacity: 0;
  transform: scale(0);
}

.mod-enter-active, .mod-leave-active {
  transition: all 300ms ease;
}
</style>